/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import PaymentInquiryContainer from './inquiry/PaymentInquiryContainer';

function PaymentsContainer({ match }) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/inquiry`} />}
      />
      <Route
        exact
        path={`${match.path}/inquiry`}
        component={PaymentInquiryContainer}
      />
    </Switch>
  );
}

PaymentsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(PaymentsContainer);
